import mediaQueries from "@tesla/design-system-tokens/dist/media.js";

var matchCustomMediaQuery = function matchCustomMediaQuery(query) {
  var defaultMatch = {
    addEventListener: null,
    matches: false,
    media: query,
    removeEventListener: null
  };

  if (typeof window !== "undefined") {
    var _window$matchMedia, _window$matchMedia2, _window;

    return (_window$matchMedia = (_window$matchMedia2 = (_window = window).matchMedia) === null || _window$matchMedia2 === void 0 ? void 0 : _window$matchMedia2.call(_window, query)) !== null && _window$matchMedia !== void 0 ? _window$matchMedia : defaultMatch;
  }

  return defaultMatch;
};

var matchMediaQuery = function matchMediaQuery(query) {
  return matchCustomMediaQuery(mediaQueries[query]);
};

var isMedia = function isMedia(query) {
  return matchMediaQuery(query).matches;
};

var isPhoneOnly = function isPhoneOnly() {
  return isMedia("phone-only");
};

var isTabletPortraitOnly = function isTabletPortraitOnly() {
  return isMedia("tablet-portrait-only");
};

var isTabletPortraitUp = function isTabletPortraitUp() {
  return isMedia("tablet-portrait-up");
};

var isTabletLandscapeOnly = function isTabletLandscapeOnly() {
  return isMedia("tablet-landscape-only");
};

var isTabletLandscapeUp = function isTabletLandscapeUp() {
  return isMedia("tablet-landscape-up");
};

var isDesktopOnly = function isDesktopOnly() {
  return isMedia("desktop-only");
};

var isDesktopUp = function isDesktopUp() {
  return isMedia("desktop-up");
};

var isDesktopLargeUp = function isDesktopLargeUp() {
  return isMedia("desktop-large-up");
};

var isDensity2x = function isDensity2x() {
  return isMedia("density--2x");
};

var isDensity3x = function isDensity3x() {
  return isMedia("density--3x");
};

var isDensity4x = function isDensity4x() {
  return isMedia("density--4x");
};

export { isDensity2x, isDensity3x, isDensity4x, isDesktopLargeUp, isDesktopOnly, isDesktopUp, isMedia, isPhoneOnly, isTabletLandscapeOnly, isTabletLandscapeUp, isTabletPortraitOnly, isTabletPortraitUp, matchCustomMediaQuery, matchMediaQuery };